import React, { useState, useEffect } from 'react'
import no from '../../../Assets/Images/Login/no.svg'
import './generateSalesOrder.css'
import { Formik, Field, Form } from 'formik'
import { BoxArrowUp } from 'react-bootstrap-icons'

import { t } from 'i18next'
import renderGenericMultipleSelectForm from 'Components/GenericMultipleSelectForm'
import { useSelector } from 'react-redux'
import { CircularProgress } from '@mui/material'
import { validateRoles, sanitizeOrderNumber } from 'Utils/functions'
import { salesRoles, EMPTY_GUID } from 'Utils/constants'

const GenerateSalesOrder = ({
  setShowModalGenerateSalesOrder,
  processSalesOrder,
  originalCreditAccount,
}) => {
  const [showCreditExtraFields, setShowCreditExtraFields] = useState(true)
  const [errorCreditAccount, setErrorCreditAccount] = useState(null)
  const [errorOrderNumber, setErrorOrderNumber] = useState(null)
  const [file, setFile] = useState(null)
  const [fileName, setFileName] = useState('')
  const [showComercialDropdown, setShowComercialDropdown] = useState(false)
  const [accountSelectedState, setAccountSelectedState] = useState('')
  const [loading, setLoading] = useState(false)
  const { creditAccountsResponse } = useSelector(state => state.catalog)

  const loginInfo = useSelector(state => state.login?.user?.AuthenticationInfo)
  const hasCustomerServiceRol = validateRoles(
    loginInfo.UserRoles,
    salesRoles.customerService
  )

  const isCreditAccountLocked =
    originalCreditAccount?.CreditAccountId &&
    originalCreditAccount.CreditAccountId !== EMPTY_GUID

  const clientHasCreditAccount =
    creditAccountsResponse?.message !== 'ERROR' &&
    creditAccountsResponse?.Data?.length

  const disableSubmitButton = showCreditExtraFields
    ? !accountSelectedState
    : false

  const closeModalConfirmStartSalesOrder = () => {
    setShowModalGenerateSalesOrder(false)
  }

  const handleCreditRadioSelected = (isCredit, values) => {
    if (isCreditAccountLocked) return

    if (!isCredit) {
      values.orderNumber = ''
      setFile(null)
    }

    setShowCreditExtraFields(isCredit)
  }

  const onChangeFile = e => {
    const file = e.target.files[0]
    setFileName(file.name)
    setFile(file)
  }

  function validateCreditAccount(value) {
    if (value === null || value === '') {
      setErrorCreditAccount(t('GENERATE_SALES_ORDER_T.REQUIRED_CAMP'))
      return false
    }

    if (value?.CreditAccountId === EMPTY_GUID) {
      setErrorCreditAccount(t('GENERATE_SALES_ORDER_T.INVALID_CREDIT_ACCOUNT'))
      return false
    }

    setErrorCreditAccount(null)
    return true
  }

  function validateOrderNumber(value) {
    const sanitized = sanitizeOrderNumber(value)
    if (!sanitized) {
      setErrorOrderNumber(t('GENERATE_SALES_ORDER_T.REQUIRED_CAMP'))
      return false
    }
    if (sanitized !== value) {
      setErrorOrderNumber(t('GENERATE_SALES_ORDER_T.INVALID_ORDER_NUMBER'))
      return false
    }
    setErrorOrderNumber(null)
    return true
  }

  const validateSalesOrder = async values => {
    let isValid = true

    if (showCreditExtraFields) {
      values.file = file

      if (isCreditAccountLocked) {
        values.orderNumber = sanitizeOrderNumber(values.orderNumber)
        isValid =
          isValid &&
          validateOrderNumber(values.orderNumber) &&
          validateCreditAccount(originalCreditAccount)
      } else {
        isValid =
          isValid &&
          validateCreditAccount(accountSelectedState) &&
          validateOrderNumber(values.orderNumber) &&
          accountSelectedState !== null
      }
    }
    if (!isValid) return

    setLoading(true)

    await processSalesOrder({
      ...values,
      accountItemSelected: isCreditAccountLocked
        ? originalCreditAccount
        : accountSelectedState,
    })
    setLoading(false)
  }

  useEffect(() => {
    if (isCreditAccountLocked) {
      setAccountSelectedState(originalCreditAccount)
      setShowCreditExtraFields(true)
    } else if (hasCustomerServiceRol) {
      handleCreditRadioSelected(false, { credit: 'no' })
    }
  }, [hasCustomerServiceRol, isCreditAccountLocked])

  return (
    <div className="modal-box-generate-sales-order">
      <div className="modal-box-generate-sales-order-container">
        <div className="confirmation-header">
          <span
            onClick={closeModalConfirmStartSalesOrder}
            className="close-modal">
            <img src={no} alt="close" />
          </span>
        </div>
        <div>
          <Formik
            initialValues={{
              credit:
                hasCustomerServiceRol && !isCreditAccountLocked ? 'no' : 'yes',
              direct: '',
              orderNumber: '',
              file: '',
            }}
            onSubmit={async values => {
              await validateSalesOrder(values)
            }}>
            {({ values }) => (
              <Form>
                <div id="radio-credit" className="form-field-title">
                  {t('GENERATE_SALES_ORDER_T.COMERCIAL_CREDIT_LABEL')}
                </div>
                <div
                  role="group"
                  aria-labelledby="radio-credit"
                  className="mt-2">
                  <label className="form-field-option">
                    <Field
                      type="radio"
                      name="credit"
                      value="yes"
                      disabled={hasCustomerServiceRol || isCreditAccountLocked}
                      checked={isCreditAccountLocked ? true : undefined}
                      onClick={() => handleCreditRadioSelected(true, values)}
                    />
                    <span>{t('GENERATE_SALES_ORDER_T.YES_OPTION_LABEL')}</span>
                  </label>
                  <label className="form-field-option ms-5">
                    <Field
                      type="radio"
                      name="credit"
                      value="no"
                      disabled={isCreditAccountLocked}
                      onClick={() => handleCreditRadioSelected(false, values)}
                    />
                    <span>{t('GENERATE_SALES_ORDER_T.NO_OPTION_LABEL')}</span>
                  </label>
                </div>
                {showCreditExtraFields && (
                  <div id="credit-extra-fields" className="credit-extra-fields">
                    {isCreditAccountLocked ? (
                      <div className="form-field-title">
                        {t('GENERATE_SALES_ORDER_T.EFECCTIVE_ACCOUNT_TITLE')}
                        <div
                          className="generic-multiple-address-filter-content"
                          style={{ opacity: 0.6, pointerEvents: 'none' }}>
                          <h2 className="generic-multiple-address-label-text">
                            {originalCreditAccount.CreditAccountNumber +
                              ' - ' +
                              (originalCreditAccount.Description || '')}
                          </h2>
                        </div>
                        <div
                          className="field-info-msg"
                          style={{
                            color: '#6c757d',
                            fontSize: '12px',
                            marginTop: '4px',
                          }}>
                          {t('GENERATE_SALES_ORDER_T.CREDIT_ACCOUNT_LOCKED')}
                        </div>
                      </div>
                    ) : clientHasCreditAccount ? (
                      renderGenericMultipleSelectForm(
                        t('GENERATE_SALES_ORDER_T.EFECCTIVE_ACCOUNT_TITLE'),
                        showComercialDropdown,
                        setShowComercialDropdown,
                        accountSelectedState,
                        setAccountSelectedState,
                        creditAccountsResponse?.Data?.filter(
                          acc => acc.CreditAccountId !== EMPTY_GUID
                        ),
                        t(
                          'GENERATE_SALES_ORDER_T.EFECCTIVE_ACCOUNT_PLACEHOLDER'
                        ),
                        'DEL',
                        false,
                        'Description'
                      )
                    ) : null}
                    {!isCreditAccountLocked &&
                    ((errorCreditAccount && errorCreditAccount !== '') ||
                      !clientHasCreditAccount) ? (
                      <div className="field-error-msg">
                        {errorCreditAccount ||
                          'No se han podido rescatar las cuentas'}
                      </div>
                    ) : null}
                    <div className="form-field-title mt-4">
                      <label htmlFor="order-number">
                        {t('GENERATE_SALES_ORDER_T.BUY_ORDER_LABEL')}
                      </label>
                      <div>
                        <Field
                          className="form-field-text-input"
                          id="order-number"
                          name="orderNumber"
                          placeholder={t(
                            'GENERATE_SALES_ORDER_T.SET_BUY_ORDER_PLACEHOLDER'
                          )}
                          value={values.orderNumber}
                          onBlur={event => {
                            const originalValue = event.target.value
                            const sanitized = sanitizeOrderNumber(originalValue)
                            event.target.value = sanitized
                            values.orderNumber = sanitized
                            validateOrderNumber(originalValue)
                          }}
                        />
                      </div>
                      {errorOrderNumber && errorOrderNumber !== '' && (
                        <div className="field-error-msg">
                          {errorOrderNumber}
                        </div>
                      )}
                    </div>
                    <div className="form-field-title mt-4">
                      <label>
                        {t('GENERATE_SALES_ORDER_T.SET_BUY_ORDER_FILE_LABEL')}
                      </label>
                      <div className="add-file">
                        <label htmlFor="sales-order-file-upload">
                          <BoxArrowUp />
                          {t(
                            'GENERATE_SALES_ORDER_T.SEARCH_FOR_DOCUMENT_LABEL'
                          )}
                        </label>
                        <input
                          id="sales-order-file-upload"
                          type="file"
                          style={{ display: 'none' }}
                          accept=".pdf,.png,.jpg,.jpeg"
                          onChange={onChangeFile}
                        />
                        {fileName ? (
                          <div className="add-file-label">{fileName}</div>
                        ) : (
                          <div className="add-file-label-placeholder">
                            {t(
                              'GENERATE_SALES_ORDER_T.FILE_NOT_SELECTED_LABEL'
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                <div className="modal-buttons">
                  <button
                    type="submit"
                    className="btn modal-si"
                    disabled={disableSubmitButton || loading}>
                    {loading ? (
                      <CircularProgress
                        sx={{
                          '& .MuiCircularProgress-svg': { color: '#FFFFFF' },
                        }}
                        size={18}
                        style={{ marginTop: '5px' }}
                      />
                    ) : (
                      t('GENERATE_SALES_ORDER_T.CONTINUE_BUTTON_LABEL')
                    )}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  )
}

export default GenerateSalesOrder
